import RolesSelect from './RolesSelect.component';

export default RolesSelect;
